// Main.js
import "./Main.css";
import React, { useContext } from "react";
import NewsGallery from "../NewsGallery/NewsGallery";
import Vacancies from "../Vacancies/Vacancies";
import CurrentMonthCalendar from "./MainCalendarV2/CurrentMonthCalendar";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/CurrentUserContext";
// import CalendarComponent from "./MainCalendar/CalendarSection/CalendarSection";
// import MainNav from "../MainNav/MainNav";

const months = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

function Main() {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const now = new Date();
  const monthTitle = `${months[now.getMonth()]} ${now.getFullYear()}`;
  const getLevelName = (level) =>
    typeof level === "string" ? level : level?.name;
  const isAdmsUser = userData?.access_levels?.some(
    (level) => getLevelName(level) === "АДМС"
  );
  // Временно отключено до полного запуска онбординга для новых пользователей.
  // const hasFirstMonthAccess = (() => {
  //   if (!userData?.created_at) return false;
  //   const createdAt = new Date(userData.created_at);
  //   if (Number.isNaN(createdAt.getTime())) return false;
  //
  //   const firstMonthEnd = new Date(createdAt);
  //   firstMonthEnd.setMonth(firstMonthEnd.getMonth() + 1);
  //   return new Date() <= firstMonthEnd;
  // })();
  const shouldShowWelcomeBlock = isAdmsUser;

  return (
    <section className="main">
      {shouldShowWelcomeBlock && (
        <div className="main__welcome-block">
          <div className="main__welcome-marquee">
            <div className="main__welcome-marquee-track">
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
              <span>Добро пожаловать в aqmol portal!</span>
            </div>
          </div>
          <div className="main__welcome-card">
            <div className="main__welcome-content">
              <div className="main__welcome-badge">Для новых сотрудников</div>
              <h3 className="main__welcome-title">
                Добро пожаловать в Aqmol-project!
              </h3>
              <p className="main__welcome-text">
                Вводные материалы помогут быстро освоиться в компании и портале
              </p>
            </div>
            <button
              type="button"
              className="main__welcome-button"
              onClick={() => navigate("/onboarding-materials")}
            >
              Посмотреть материалы
            </button>
          </div>
        </div>
      )}
      <div className="main__columns">
        <div className="main__news-block">
          <NewsGallery />
        </div>
        <div className="main__calendar-block">
          <h2 className="main__title">{monthTitle}</h2>
          <CurrentMonthCalendar />
        </div>
      </div>
      <div className="main__vacancies-block">
        <Vacancies />
      </div>
    </section>
  );
}

export default Main;
